import React, { useEffect, useState } from 'react';
import './index.css';
import apiurl from './apiurl';
import axios from 'axios';


export class KontrahenciSearch extends React.Component {
  constructor() {
    super();    
    this.state = {
      token: sessionStorage.getItem('token'),
      loadKontr: false
    };
  }
  
search = (e) => {
  e.preventDefault();
  axios
    .get(apiurl+"api/v2/Kontrahenci", { params: { search: this.state.searchValue }, headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response => 
      this.setState({ kontrData: response.data, loadKontr: false })
    )
    .catch(error => {console.log(error); this.setState({ loadKontr: false, kontrData: null})});
}


  
render() {
const { searchValue, kontrData, loadKontr } = this.state;
return (
<React.Fragment>
<div className='d-flex flex-column card p-3 w-100' >
  <form className='d-flex flex-row mb-3' onSubmit={(e) => (this.setState({ loadKontr: true }, this.search(e)))}>
    <input type='text' className='form-control w-50' onChange={(e) => (this.setState({ searchValue: e.target.value }))}></input>
    <button className='btn btn-light ml-1' type='submit' disabled={searchValue ? false : true} >Szukaj</button>
  </form>
  {loadKontr ? (<div className='d-flex flex-row justify-content-center'><div class="spinner-border text-primary m-2" role="status"><span class="sr-only">Loading...</span></div></div>) : null }
  <div className='d-flex flex-row overflow-auto'>
  {kontrData ? (<table className='table table-striped'>
    <thead style={{ position: 'sticky', zIndex: '2', top: '0', backgroundColor: '#FFFFFF'}}>
      <tr>
        <th>Nr.</th>
        <th>Nazwa kontrahenta</th>
        <th>Nazwa skrócona</th>
        <th>NIP</th>
        <th>PESEL</th>
        <th>Miejscowość</th>
        <th>Ulica</th>
        <th>Nr. bud.</th>
        <th>Nr. lok</th>
      </tr>
    </thead>
    <tbody>
      {kontrData.map((dane, idx) => {
        return (<tr key={idx} className='pointer' onClick={() => (this.props.onChangeKontr(dane.kontrahentId))} data-dismiss="modal">
          <td>{dane.kontrahentId}</td>
          <td>{dane.nazwa}</td>
          <td>{dane.nazwaKrotka}</td>
          <td>{dane.nip}</td>
          <td>{dane.pesel}</td>
          <td>{dane.miejscowosc}</td>
          <td>{dane.ulica}</td>
          <td>{dane.nrDom}</td>
          <td>{dane.nrLokalu}</td>
        </tr>)
      })}
    </tbody>
  </table>) : null }

  </div>
</div>
</React.Fragment>
);
}
}


export class SloZadan extends React.Component {
    constructor() {
      super();    
      this.state = {
        token: sessionStorage.getItem('token'),
        zPlanemCheck: false,
      };
    }

    componentDidMount() {
        this.getZadania();
    } 

    componentDidUpdate(prevProps) {
        if(this.props.idWydz !== prevProps.idWydz)
        {
            this.getZadania();
        }
    } 

    getZadania = () => {
    axios
    .get(apiurl+"api/v2/UmowyZadania", { params: { rok: this.props.rok, kodJedn: this.props.kodJedn, idWydz: this.props.idWydz, zadaniaPlan: this.state.zPlanemCheck}, headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response => 
        this.setState({ zadaniaData: response.data })
    )
    .catch(error => {console.log(error)});
    }


    
  render() {
  const {zadaniaData } = this.state;
  return (
  <React.Fragment> 
    <div className='d-flex flex-column p-3 card'>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value={this.state.zPlanemCheck} onChange={() => (this.setState({ zPlanemCheck: !this.state.zPlanemCheck }, this.getZadania()))} id="zPlanemCheck"></input>
          <label class="form-check-label" for="zPlanemCheck">Tylko zadania z planem</label>
        </div>
        <table className='table table-striped'>
            <thead>
            <tr>
                <th>ID</th>
                <th>Symbol</th>
                <th>Nazwa</th>
            </tr>
            </thead>
            <tbody>
            {zadaniaData ? (zadaniaData.map((dane, idx) => {
            return (<tr key={idx} onClick={() => (this.props.onChangeZadania(dane.idZadania))} className='pointer' data-dismiss="modal">
                <td>{dane.idZadania}</td>
                <td>{dane.symbol}</td>
                <td>{dane.nazwa}</td>
            </tr>)
            })) : null }
            </tbody>
        </table>
    </div>
  </React.Fragment>
  );
  }
  }


 
  export const Klasyfikacje = (props) => {
    const [token, setToken] = useState(sessionStorage.getItem('token'));
    const [data, setData] = useState();
    const [added, setAdded] = useState([]);


    useEffect(() => {
      axios
        .get(apiurl+"api/v2/Klasyfikacja", { params: { rok: props.rok, kodJedn: props.kodJedn, idWydz: props.idWydz, klasyfZPlan: true}, headers: { 'Authorization' : token }})
        .then(response => {
          setData(response.data)
        })
        .catch(error => {console.log(error)});
  
    }, [props.idWydz]);


    return (<>
    <div className='d-flex flex-column p-3 card'>
        <table className='table table-striped'>
            <thead>
            <tr>
                <th>Dział</th>
                <th>Rozdział</th>
                <th>Paragraf</th>
                <th>Pozycja</th>
                <th>B/P</th>
                <th>Nazwa</th>
            </tr>
            </thead>
            <tbody>
            {data ? (data.map((dane, idx) => {
                const zawiera = added.includes(idx);
                return (<tr className='pointer' key={idx}>
                    <td>{!zawiera ? (<button className='btn btn-light' onClick={(e) => (props.addKlasyfikacjePop(e, dane), setAdded(added => [...added, idx]))}>+</button>) : (<button className='btn btn-light' disabled>+</button>)}</td>
                    <td>{dane.dzial}</td>
                    <td>{dane.rozdzial}</td>
                    <td>{dane.paragraf}</td>
                    <td>{dane.pozycja}</td>
                    <td>{dane.bp}</td>
                    <td>{dane.nazwa}</td>
                </tr>)
            })) : null }
            </tbody>
        </table>
    </div>
    </>)
  }


  export const NumerWnioskuPop = (props) => {
    const [token, setToken] = useState(sessionStorage.getItem('token'));
    const [data, setData] = useState();
    const [added, setAdded] = useState([]);


    useEffect(() => {
      axios
        .get(apiurl+"api/v2/Klasyfikacja", { params: { rok: props.rok, kodJedn: props.kodJedn, idWydz: props.idWydz, klasyfZPlan: true}, headers: { 'Authorization' : token }})
        .then(response => {
          setData(response.data)
        })
        .catch(error => {console.log(error)});
  
    }, [props.idWydz]);


    return (<>
    <div className='d-flex flex-column p-3 card'>
        <table className='table table-striped'>
            <thead>
            <tr>
                <th>Dział</th>
                <th>Rozdział</th>
                <th>Paragraf</th>
                <th>Pozycja</th>
                <th>B/P</th>
                <th>Nazwa</th>
            </tr>
            </thead>
            <tbody>
            {data ? (data.map((dane, idx) => {
                const zawiera = added.includes(idx);
                return (<tr className='pointer' key={idx}>
                    <td>{!zawiera ? (<button className='btn btn-light' onClick={(e) => (props.addKlasyfikacjePop(e, dane), setAdded(added => [...added, idx]))}>+</button>) : (<button className='btn btn-light' disabled>+</button>)}</td>
                    <td>{dane.dzial}</td>
                    <td>{dane.rozdzial}</td>
                    <td>{dane.paragraf}</td>
                    <td>{dane.pozycja}</td>
                    <td>{dane.bp}</td>
                    <td>{dane.nazwa}</td>
                </tr>)
            })) : null }
            </tbody>
        </table>
    </div>
    </>)
  }
